export var JoyAuthServiceAuthProvider;
(function (JoyAuthServiceAuthProvider) {
    JoyAuthServiceAuthProvider["apple"] = "apple";
    JoyAuthServiceAuthProvider["google"] = "google";
})(JoyAuthServiceAuthProvider || (JoyAuthServiceAuthProvider = {}));
export default class JoyAuthService {
    static initialize(provider) {
        JoyAuthService.provider = provider;
    }
    static get instance() {
        return JoyAuthService.provider;
    }
}
JoyAuthService.provider = null;
//# sourceMappingURL=JoyAuthService.js.map